import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export default function Monitoring({ providerId }: { providerId: number }) {
  const PREFIX = 'Monitoring';

  const classes = {
    container: `${PREFIX}-container`,
  };

  const StyledBox = styled(Box)(({ theme }) => ({
    [`&.${classes.container}`]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      backgroundColor: 'rgba(1, 16, 18, 0.04)',
      height: '178px',
      width: '100%',
      color: 'rgb(224, 224, 224)',
    },
  }));

  return (
    <StyledBox className={classes.container}>
      <Typography variant="h5" color="rgba(1, 16, 18, 0.90)">
        Coming soon
      </Typography>
    </StyledBox>
  );
}
